import React from 'react';
import { Link } from 'react-router-dom';
import { ClompApi } from '../api/ClompApi';
import { timeAgo } from '../api/presence';

const api = new ClompApi();

// Which reports the page lists
const FILTERS = [
    { id: 'open', name: 'Open' },
    { id: 'resolved', name: 'Resolved' },
    { id: 'all', name: 'All' }
];
const KINDS = [
    { id: 'all', name: 'Bugs and suggestions' },
    { id: 'bug', name: 'Bugs' },
    { id: 'suggestion', name: 'Suggestions' }
];

// The admin panel's Bugs & Suggestions page, for Admins and Founders: what players have sent from the button in the
// corner of every page, open ones first, each of which can be marked resolved (or open again) or removed.
export class AdminFeedback extends React.Component {

    state = {
        loading: true,
        failed: false,
        feedback: [],
        filter: 'open',
        kind: 'all',
        // the id of the report being changed, the one whose Remove is waiting to be confirmed, and what went wrong
        busy: null,
        confirming: null,
        error: null
    };

    componentDidMount() {
        api.admin.getFeedback().then((data) => {
            this.setState({ loading: false, feedback: data.feedback });
        }).catch((err) => {
            console.log('Error loading reports: ', err);
            this.setState({ loading: false, failed: true });
        });
    }

    change(report, request) {
        this.setState({ busy: report.id, error: null });
        request.then((data) => {
            this.setState({ busy: null, confirming: null, feedback: data.feedback });
        }).catch((err) => {
            let message = err.response && err.response.data && err.response.data.message;
            this.setState({ busy: null, confirming: null, error: message || "Couldn't change that report. Please try again." });
        });
    }

    renderReport(report) {
        let { busy, confirming } = this.state;
        let resolved = report.status === 'resolved';
        return (
            <li key={report.id} className={`adm-report adm-report-${report.kind}${resolved ? ' is-resolved' : ''}`}>
                <div className="adm-report-head">
                    <span className={`adm-report-kind adm-report-kind-${report.kind}`}>{report.kind === 'bug' ? 'Bug' : 'Suggestion'}</span>
                    <span className="adm-report-from">
                        {report.from ? <Link to={`/profile/${encodeURIComponent(report.from.username)}`}>{report.from.username}</Link> : <em>Deleted account</em>}
                    </span>
                    <span className="adm-report-when" title={new Date(report.createdAt).toLocaleString()}>{timeAgo(report.createdAt)}</span>
                    {report.page ? <span className="adm-report-page">on <code>{report.page}</code></span> : null}
                    {resolved ? <span className="adm-report-done">Resolved {report.resolvedAt ? timeAgo(report.resolvedAt) : ''}</span> : null}
                </div>
                <p className="adm-report-message">{report.message}</p>
                <div className="adm-actions">
                    {confirming === report.id ?
                        <span className="adm-confirm" role="group" aria-label="Remove this report?">
                            <button type="button" className="adm-delete adm-delete-sure" disabled={busy === report.id} onClick={() => this.change(report, api.admin.deleteFeedback(report.id))}>
                                {busy === report.id ? 'Removing...' : 'Remove for good'}
                            </button>
                            <button type="button" className="adm-cancel" disabled={busy === report.id} onClick={() => this.setState({ confirming: null })}>Cancel</button>
                        </span>
                        :
                        <>
                            <button type="button" className={resolved ? 'adm-details' : 'adm-save'} disabled={busy === report.id}
                                onClick={() => this.change(report, api.admin.setFeedbackStatus(report.id, resolved ? 'open' : 'resolved'))}>
                                {resolved ? 'Reopen' : 'Mark resolved'}
                            </button>
                            <button type="button" className="adm-delete" disabled={busy === report.id} onClick={() => this.setState({ confirming: report.id })}>Remove</button>
                        </>
                    }
                </div>
            </li>
        );
    }

    render() {
        let { loading, failed, feedback, filter, kind, error } = this.state;
        let count = (status) => feedback.filter((report) => report.status === status).length;
        let shown = feedback.filter((report) => (filter === 'all' || report.status === filter) && (kind === 'all' || report.kind === kind));
        return (
            <section>
                <div className="adm-head">
                    <h2>Bugs &amp; Suggestions</h2>
                    {!loading && !failed ?
                        <div className="adm-filters">
                            <div className="adm-tabs" role="group" aria-label="Which reports">
                                {FILTERS.map((option) => (
                                    <button key={option.id} type="button" className={filter === option.id ? 'is-on' : ''} aria-pressed={filter === option.id} onClick={() => this.setState({ filter: option.id })}>
                                        {option.name}{option.id !== 'all' ? ` (${count(option.id)})` : ''}
                                    </button>
                                ))}
                            </div>
                            <select className="adm-select" aria-label="Kind of report" value={kind} onChange={(e) => this.setState({ kind: e.target.value })}>
                                {KINDS.map((option) => <option key={option.id} value={option.id}>{option.name}</option>)}
                            </select>
                        </div>
                        : null}
                </div>
                <p className="adm-note">Sent by logged-in players from the button in the bottom left corner of every page. Only Admins and Founders can see them.</p>
                {error ? <p className="adm-error" role="alert">{error}</p> : null}
                {loading ? <p className="adm-empty">Loading reports...</p>
                    : failed ? <p className="adm-error" role="alert">Couldn't load the reports. Please try again later.</p>
                    : shown.length === 0 ? <p className="adm-empty">{filter === 'open' ? 'Nothing open. All caught up!' : 'No reports here.'}</p>
                    : <ul className="adm-reports">{shown.map((report) => this.renderReport(report))}</ul>}
            </section>
        );
    }

}
